import React, { memo, useMemo } from "react";
import styles from "./PrivateHeader.module.scss";
import UserInfoDropdown from "../../../common/components/user-info-dropdown/UserInfoDropdown";
import { MobileMenu, NotificationIcon } from "../../../assets/icons";
import { useLocation } from "react-router-dom";

type Props = {
	isColapsed: boolean;
	onMenuClick: () => void;
	onMobileMenuClick: () => void;
};

const PrivateHeader: React.FC<Props> = memo((props: Props) => {
	const { onMenuClick, onMobileMenuClick, isColapsed } = props;
	const { pathname } = useLocation();

	const title = useMemo(()=>{ 
		switch(pathname){
			case "/customer/dashboard":
				return "Dashboard";
			default :return "";

		}
	},[pathname])
	

	return (
		<div>
			<div className={`${styles.container} ${isColapsed ? styles.colapsed : ""}`}>
				<div className={`${styles.logoContainer} ${styles.logoContainerColapsed}`}>
					<img className={styles.logo} src="../../../images/landing-page-header-icon.png" alt="placeholder" />
				</div>
				<button className={`standardButton ${styles.button}`} onClick={onMenuClick}>
					<svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M0.5 11V9.49998H5.87498V11H0.5ZM0.5 6.24995V4.75H11.6827V6.24995H0.5ZM0.5 1.49998V0H17.5V1.49998H0.5Z" fill="#1C1B1F" />
					</svg>
				</button>
				<UserInfoDropdown />
			</div>
			<div className={styles.mobileContainer}>
				<MobileMenu className={styles.mobileMenu} onClick={onMobileMenuClick} />
				<span className={styles.header}>{title}</span>
			</div>
		</div>
	);
});

export default PrivateHeader;
